import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm, Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { CnafUserService, NgCnafFormFocusToFirstInvalidDirective, CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { GlobalPubSubService } from '../services/globalpubsub.service';
import { LIBELLE_EVENT_CAMILLE, REGEX_COURRIEL, LIBELLE_STAT } from '../constants/configlibelles';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { Router } from '@angular/router';
import { Reponses } from '../models/reponses.model';
import { TagXitiService } from '../services/tagxiti.service';
import { context } from '../../contexts/context';

@Component({
  selector: 'cnaf-contacter-caf-courriel-reponses',
  templateUrl: './contactercafcourrielreponses.component.html',
  styleUrls: ['./contactercafcourrielreponses.component.css']
})
export class ContacterCafCourrielReponsesComponent implements OnInit {
  myForm!: FormGroup<{
    satisfaction: FormControl<string | null>,
    actionReponses: FormControl<string | null>,
    texteCourriel: FormControl<string | null>,
  }>;
  reponsesCamille: Reponses;
  questionCamille: string;
  etatCamille: string;
  formuel: boolean;
  paramsMessage: any;
  rnProduct: string;
  limit: number;
  tempReponseId: string;
  isEnvoiDisabled: boolean;
  isCheckboxDisabled: boolean;
  tagOk: boolean;
  codeOrga: string;
  libelleMotifFormuel: string;
  indicateursSite: any;
  QUERY_SOURCE = 'CMC';
  submitted: boolean;

  @ViewChild('reponsesCourrielNgForm', { static: false }) public reponsesCourrielNgForm!: NgForm;

  constructor(private readonly formBuilder: FormBuilder,
    private readonly cnafUserService: CnafUserService,
    private readonly globalPubSubService: GlobalPubSubService,
    private readonly cnafContacterMaCafService: CnafContacterMaCafService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly tagXitiService: TagXitiService,
    private readonly cnafAtTagService: CnafAtTagService) {
    this.myForm = this.formBuilder.group({
      satisfaction: '',
      actionReponses: '',
      texteCourriel: ['',
        {
          validators: [
            Validators.required,
            Validators.minLength(1)
          ]
        }
      ]
    });
    this.reponsesCamille = {} as Reponses;
    this.questionCamille = '';
    this.etatCamille = '';
    this.formuel = false;
    this.paramsMessage = {};
    this.rnProduct = '';
    this.limit = 0;
    this.tempReponseId = '';
    this.isEnvoiDisabled = false;
    this.isCheckboxDisabled = false;
    this.tagOk = false;
    this.codeOrga = '';
    this.libelleMotifFormuel = '';
    this.indicateursSite = {};
    this.submitted = false;
  }

  ngOnInit(): void {
    if (this.cnafContacterMaCafService.reponsesGeneres) {
      const ancreContenur = document.querySelector('#conteneur-reponses');
      if (ancreContenur) {
        ancreContenur.scrollIntoView();
      }
      this.reponsesCamille = window.history.state?.paramsCamille?.reponsesCamille;
      this.questionCamille = window.history.state?.paramsCamille?.questionCamille;
      this.etatCamille = window.history.state?.paramsCamille?.etatCamille;
      this.formuel = window.history.state?.paramsCamille?.formuel;
      this.paramsMessage = window.history.state?.paramsMessage;
      this.rnProduct = window.history.state?.paramsCamille?.rnProduct;
      this.limit = 5;
      this.codeOrga = this.cnafUserService.codeOrga;
      this.indicateursSite = {
        x4: '',
        x11: '',
        x12: '',
        x13: ''
      };
      this.creationStatsImpression();
    }
    else {
      this.router.navigate(['contactcafcourriel']);
    }
  }

  private creationStatsImpression() {
    if (this.reponsesCamille?.resultats) {
      for (let i = 0; i < this.reponsesCamille.resultats.length; i++) {
        this.reponsesCamille.resultats[i].open = false;
        if (i < this.limit && this.limit === 5 || i >= 5 && this.limit === 10) {
          this.createStatImpression(this.reponsesCamille.resultats[i].titre, this.reponsesCamille.resultats[i].typeArticle);
        }
      }
    }
  }

  createStatImpression(titre: string, typeArticle: string): void {
    if (this.questionCamille.indexOf('$ ') >= 0) {
      this.libelleMotifFormuel = this.questionCamille.split('$ ')[1];
    }
    const param2 = this.cnafContacterMaCafService.clean(this.paramsMessage.selObjetMessage.libelleCaffr);
    const param3 = this.cnafContacterMaCafService.clean(typeArticle);
    const param4 = this.cnafContacterMaCafService.clean(titre);
    const param5 = this.cnafContacterMaCafService.clean(this.libelleMotifFormuel);
    const publisherSetObj = this.tagXitiService.getAtPublisherSetObject(LIBELLE_STAT.libelleReponse, this.codeOrga, param2, param3, param5, param4);
    this.cnafAtTagService.publisherSend(publisherSetObj);
  }

  submit(): void {
    this.globalPubSubService.fireEvent(LIBELLE_EVENT_CAMILLE.envoi, []);
    // Désactivation du bouton à la soumission
    this.isEnvoiDisabled = true;
    // Suppression Unicode "Control Characters"
    // Sauf LF,CR,Horizontal TAB
    let questionCamille = this.questionCamille.
      replace(REGEX_COURRIEL.value, '');
    if (questionCamille.indexOf('$ ') >= 0) {
      questionCamille = questionCamille.split('$ ')[1];
    }
    let texteCourriel = '';
    if (this.myForm.controls.texteCourriel.value) {
      texteCourriel = this.myForm.controls.texteCourriel.value
        .replace(REGEX_COURRIEL.value, '');
    }
    const data = {
      objetMessage: this.paramsMessage.selObjetMessage.code,
      motifReclamation: null,
      prestation: null,
      msg: `${this.formuel ? 'L\'objet de votre recherche :' : 'Rappel de la question :'}\n${questionCamille}\n\nMessage courriel :\n${texteCourriel}`,
      nomCaf: this.cnafContacterMaCafService.getNomCaf(),
      idSousMotifMessage: this.rnProduct
    };
    this.cnafContacterMaCafService.postForm(data).subscribe({
      next: (data: any) => {
        this.postFormOk(data);
      },
      error: () => {
        this.postFormKo();
      }
    });
    window.scrollTo(0, 0);
  }

  postFormOk(response: any): void {
    this.isEnvoiDisabled = false;
    const args = { args: this.paramsMessage.selObjetMessage.statSid, args2: this.rnProduct };
    this.globalPubSubService.fireEvent(LIBELLE_EVENT_CAMILLE.envoiOk, [args]);
    this.indicateursSite.x11 = this.paramsMessage.selObjetMessage.libelleCaffr;
    if (this.reponsesCamille === null) {
      this.indicateursSite.x12 = '0';
    } else {
      this.indicateursSite.x12 = '1';
    }
    if (this.questionCamille.indexOf('$ ') >= 0) {
      this.indicateursSite.x13 = this.questionCamille.split('$ ')[1];
    }
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoi, context.type, this.codeOrga,
      LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    this.router.navigate(['contactcafcourriel']);
  }

  postFormKo(): void {
    this.isEnvoiDisabled = false;
    this.globalPubSubService.fireEvent(LIBELLE_EVENT_CAMILLE.envoiKo, []);

    this.indicateursSite.x4 = '1';
    this.indicateursSite.x11 = this.paramsMessage.selObjetMessage.libelleCaffr;
    if (this.reponsesCamille === null) {
      this.indicateursSite.x12 = '0';
    } else {
      this.indicateursSite.x12 = '1';
    }
    if (this.questionCamille.indexOf('$ ') >= 0) {
      this.indicateursSite.x13 = this.questionCamille.split('$ ')[1];
    }
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoi, context.type, this.codeOrga,
      LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    this.router.navigate(['contactcafcourriel']);
  }

  getArticle(resultat: any): void {
    resultat.etatArticle = 'loading';
    this.tempReponseId = resultat.reponseId;
    const params = {
      sessionId: this.reponsesCamille.sessionId,
      transactionId: this.reponsesCamille.transactionId,
      reponseId: resultat.reponseId,
      pointEntree: this.QUERY_SOURCE,
      cleRnProduit: this.reponsesCamille.cleRnProduit,
      modeFormuel: this.formuel.toString(),
      globalReponseId: resultat.globalReponseId
    };
    this.cnafContacterMaCafService.getArticle(params).subscribe({
      next: (data: any) => {
        this.getArticleOk(data);
      },
      error: () => {
        this.getArticleKo();
      }
    });
  }

  getArticleOk(responseData: any): void {
    // Gestion Reset Session IMNET
    if (responseData.sessionId !== this.reponsesCamille.sessionId) {
      this.reponsesCamille.sessionId = responseData.sessionId;
      this.reponsesCamille.transactionId = '1';
    }
    const reponseId = responseData.reponseId;
    for (const value of this.reponsesCamille.resultats) {
      if (value.reponseId === reponseId) {
        if (this.cnafContacterMaCafService.isUndefOrNull(responseData.contenu) || responseData.contenu.length === 0) {
          value.etatArticle = 'vide';
        } else {
          value.etatArticle = 'loaded';
          value.contenu = responseData.contenu;
          value.typeArticle = responseData.typeArticle;
          value.isLu = true;

          if (this.questionCamille.indexOf('$ ') >= 0) {
            this.libelleMotifFormuel = this.questionCamille.split('$ ')[1];
          }
          const param2 = this.cnafContacterMaCafService.clean(this.paramsMessage.selObjetMessage.libelleCaffr);
          const param3 = this.cnafContacterMaCafService.clean(value.typeArticle);
          const param4 = this.cnafContacterMaCafService.clean(value.titre);
          const param5 = this.cnafContacterMaCafService.clean(this.libelleMotifFormuel);
          const publisherSetObj = this.tagXitiService.getAtClickPublisherSetObject(LIBELLE_STAT.libelleReponse, this.codeOrga, param2, param3, param5, param4);
          this.cnafAtTagService.publisherSend(publisherSetObj);
        }
      }
    }
  }
  getArticleKo(): void {
    for (const value of this.reponsesCamille.resultats) {
      if (value.reponseId === this.tempReponseId) {
        value.etatArticle = 'error';
      }
    }
  }

  triggerAction(action: string): void {
    if (this.isCheckboxDisabled) {
      return;
    }
    if (action && action === 'modifier') {
      this.isCheckboxDisabled = true;
      setTimeout(() => {
        // Si on se souvient du nir, on pré remplit le champ du formulaire
        this.globalPubSubService.fireEvent(LIBELLE_EVENT_CAMILLE.reset, []);
        this.router.navigate(['contactcafcourriel']);
        window.scrollTo(0, 0);
      }, 100);

      // Tag classique lorsqu'on modifie le formuel
      const tagObj = this.tagXitiService.getAtTagObject('contactcafcourriel', context.type, 'contactermacaf', '', '');
      this.cnafAtTagService.pageSend(tagObj);
    }
  }

  voirPlusMoins(): void {
    if (this.limit === 5) {
      this.limit = 10;
      if (!this.tagOk) {
        for (let i = 0; i < this.reponsesCamille.resultats.length; i++) {
          if (i < this.limit && this.limit === 5 || i >= 5 && this.limit === 10) {
            this.createStatImpression(this.reponsesCamille.resultats[i].titre, '');
          }
        }
        this.tagOk = true;
      }
    } else {
      this.limit = 5;
    }
  }

  ouvrirLien(resultat: any): void {
    window.open(resultat.lien, '_blank');
    for (const value of this.reponsesCamille.resultats) {
      if (value.reponseId === resultat.reponseId) {
        if (!value.isLu) {
          // Appel sans gestion de retour
          // -> Inscription Statistique clickedArticle
          const params = {
            sessionId: this.reponsesCamille.sessionId,
            transactionId: this.reponsesCamille.transactionId,
            reponseId: resultat.reponseId,
            pointEntree: this.QUERY_SOURCE,
            cleRnProduit: this.reponsesCamille.cleRnProduit,
            modeFormuel: this.formuel.toString()
          };
          this.cnafContacterMaCafService.statLienArticle(params);
          value.isLu = true;

          if (this.questionCamille.indexOf('$ ') >= 0) {
            this.libelleMotifFormuel = this.questionCamille.split('$ ')[1];
          }
          const param2 = this.cnafContacterMaCafService.clean(this.paramsMessage.selObjetMessage.libelleCaffr);
          const param3 = this.cnafContacterMaCafService.clean(value.typeArticle);
          const param4 = this.cnafContacterMaCafService.clean(value.titre);
          const param5 = this.cnafContacterMaCafService.clean(this.libelleMotifFormuel);
          const publisherSetObj = this.tagXitiService.getAtClickPublisherSetObject(LIBELLE_STAT.libelleReponse, this.codeOrga, param2, param3, param5, param4);
          this.cnafAtTagService.publisherSend(publisherSetObj);
        }
      }
    }
  }

  imprimer(): void {
    this.tagguerClick(LIBELLE_STAT.libelleImprimer);
    window.print();
  }

  tagguerClick(name: string): void {
    const clickInfo = this.tagXitiService.getAtClickObject(name, 'action', this.codeOrga, LIBELLE_STAT.libelleContacterMaCaf, LIBELLE_STAT.libelleParCourriel);
    this.cnafAtTagService.click(clickInfo);
  }

  openClose(index: number): void {
    const article = this.reponsesCamille.resultats[index];
    if (article.etatArticle !== 'loaded' && !article.open) {
      this.getArticle(article);
    }
    article.open = !article.open;
  }

  resultatById(index: number, resultat: any): any {
    return resultat.reponseId;
  }

  redirect(url: string): void {
    window.location.href = url;
    window.scrollTo(0, 0);
  }

  validateFormAndBlur(): void {
    NgCnafFormFocusToFirstInvalidDirective.focusToFirstElementInvalid(this.reponsesCourrielNgForm, 120, this.elementRef);
  }

  submitOrBlur(): void {
    this.submitted = true;
    this.myForm.valid ? this.submit() : this.validateFormAndBlur();
  }

  confirmerClick(): void {
    const message = 'Confirmez-vous l\'abandon de l\'envoi de votre message ?';
    if (confirm(message)) {
      this.tagguerClick('quitter_non_satisfait');
      this.redirect('/redirect/s/Redirect?page=monCompteContactCaf#/contactcaf');
    }
  }
}
